import {useContext, useState} from 'react'
import {SupplierMappingDetails} from '../../context'
import CreateSupplierMappingModal from '../modals/CreateSupplierMappingModal'
import MultiSelect from '../../../../components/MultiSelect/MultiSelect'
import Search from '../../../../components/Search'
import {useSearchParams} from 'react-router-dom'
import DeleteSupplierMappingModal from '../modals/DeleteSupplierMappingModal'

const SupplierMappingHeader = () => {
  const {
    hasWritePermission,
    allBrands,
    isLoadingAllBrands,
    onBrandFilterChange,
    onSearch,
    checkedRows,
  } = useContext(SupplierMappingDetails)
  const [showModal, setShowModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [searchParams] = useSearchParams()
  const id = searchParams.get('id')
  const name = searchParams.get('name')

  return (
    <div className='d-flex justify-content-between align-items-center mb-10'>
      <div className='d-flex align-items-center gap-5'>
        <Search onSearch={(value: string) => onSearch(value)} />
        <MultiSelect
          id={`brands-filter`}
          label=''
          options={allBrands}
          valueType='number'
          valueKey='brand_id'
          labelKey='name'
          className='w-175px'
          placeholder='Select Brands'
          allValuesSelectedText={'Brand: All'}
          isLoading={isLoadingAllBrands}
          handleSelected={onBrandFilterChange}
        />
      </div>
      {hasWritePermission && (
        <div className='text-end'>
          {checkedRows?.length > 0 && (
            <button className='btn btn-danger me-5' onClick={() => setShowDeleteModal(true)}>
              Remove Products
            </button>
          )}
          <button onClick={() => setShowModal(true)} className='btn btn-primary'>
            <i className='bi bi-plus-lg'></i>
            Add Product
          </button>
        </div>
      )}
      {showModal && (
        <CreateSupplierMappingModal
          onClose={() => setShowModal(false)}
          isEdit={true}
          supplierMapping={{name: name, emailId: id}}
        />
      )}
      {showDeleteModal && (
        <DeleteSupplierMappingModal
          onClose={() => setShowDeleteModal(false)}
          supplierMapping={{productId: checkedRows}}
        />
      )}
    </div>
  )
}
export default SupplierMappingHeader
